/**
 * Shared helpers for file/document rows (API snake_case and local upload state).
 */

export function formatFileSize(bytes) {
  const size = Number(bytes) || 0;
  if (size < 1024) return `${size} B`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatFileIdForDisplay(fileId) {
  const value = String(fileId || '');
  if (value.length <= 8) return value;
  return value.slice(0, 8);
}

export function documentFileId(document) {
  return String(document?.file_id ?? '').trim();
}

export function documentFileName(document, fileId = documentFileId(document)) {
  const value = String(
    document?.file_name ?? document?.filename ?? document?.name ?? ''
  ).trim();
  return value || formatFileIdForDisplay(fileId);
}

export function documentRowKey(document) {
  const clientKey = String(document?._clientRowId ?? document?._clientUploadId ?? '').trim();
  if (clientKey) return clientKey;
  return String(document?.file_id ?? document?.id ?? '').trim();
}

export function documentSizeBytes(document) {
  return Number(document?.size_bytes ?? document?.file_size ?? document?.size ?? 0) || 0;
}
